import {motion} from "framer-motion"
import Layout from "./Layout"

const Section_PrivacyImpressum = ({
  navbarItems,
  sectionData,
  footerItems,
}) => (
  <motion.div
    initial={{opacity: 0}}
    animate={{opacity: 1, transition: {duration: 1}}}
    exit={{opacity: 0}}
    className="container mx-auto my-24"
  >
    <Layout navbarItems={navbarItems} footerItems={footerItems}>
      <div
        className="flex flex-col mx-10 mt-10 leading-relaxed text-left md:mx-20 xl:mx-32"
        dangerouslySetInnerHTML={{__html: sectionData.content}}
      />
    </Layout>
  </motion.div>
)

export default Section_PrivacyImpressum
